import React from "react";

function Icon({color = '#F8FAF9', ...props}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="28"
      fill="none"
      viewBox="0 0 27 28"
      {...props}
    >
      <path
        fill={color}
        d="M13.5.667c3.622 0 4.074.013 5.496.08 1.42.066 2.386.29 3.237.62a6.5 6.5 0 012.363 1.537 6.543 6.543 0 011.537 2.363c.33.85.553 1.817.62 3.237.063 1.421.08 1.873.08 5.496s-.013 4.075-.08 5.496c-.067 1.42-.29 2.387-.62 3.237a6.51 6.51 0 01-1.537 2.363 6.554 6.554 0 01-2.363 1.537c-.85.33-1.817.554-3.237.62-1.422.063-1.874.08-5.496.08-3.623 0-4.075-.013-5.496-.08-1.42-.066-2.387-.29-3.238-.62a6.52 6.52 0 01-2.362-1.537 6.538 6.538 0 01-1.538-2.363c-.33-.849-.553-1.817-.62-3.237C.184 18.075.166 17.623.166 14s.014-4.075.08-5.496c.067-1.421.29-2.387.62-3.237a6.507 6.507 0 011.538-2.363 6.53 6.53 0 012.362-1.537c.85-.33 1.816-.554 3.238-.62C9.424.684 9.877.667 13.5.667zm0 6.666a6.667 6.667 0 100 13.334 6.667 6.667 0 000-13.334zM22.166 7a1.667 1.667 0 10-3.333 0 1.667 1.667 0 003.333 0zM13.5 10a4 4 0 110 8 4 4 0 010-8z"
      ></path>
    </svg>
  );
}

export default Icon;
